export const withStopProgagation = (fn: (e) => unknown) => {
  return (e) => {
    e.stopPropagation && e.stopPropagation()
    fn(e)
  }
}
